import { ApiBase, HttpMethod } from "../../core/api-base";

export type PointRuleUpdateResponse = {
    success?: number;
    message?: string;
    item?: {
        rule_name_th?: string;
        rule_name_en?: string;
        rule_name_ja?: string;
        description_th?: string | null;
        description_en?: string | null;
        description_ja?: string | null;
        points_per_action?: number | string;
        required_count?: number;
        daily_point_limit?: number | string | null;
        notification_send_type?: string | null;
        is_active?: number;
        display_order?: number;
    };
    errors?: Record<string, string[]>;
};

export class PointRuleAdminApi extends ApiBase {
    public static update(form: HTMLFormElement, formData: FormData): Promise<Response> {
        return this.apiRequestWithErrorHandling(form.action, HttpMethod.Put, formData, {
            showErrors: false,
            fallbackMessage: "Point rule update failed.",
        });
    }
}
